import React from "react";
import { BoxIcon } from "lucide-react";
interface SectionProps {
  number: number;
  title: string;
  icon: BoxIcon;
  aside?: React.ReactNode;
  children: React.ReactNode;
}
export function Section({
  number,
  title,
  icon: Icon,
  aside,
  children
}: SectionProps) {
  const headingId = `offboarding-section-${number}`;
  return <section aria-labelledby={headingId} data-id="element-295" data-mp="2ywvwm16gr4ud">
      <div className="flex items-center gap-2.5 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2" data-id="element-296" data-mp="33ue6puw7vq3y">
        <span className="text-xs font-semibold tabular-nums text-gray-400" data-id="element-297" data-mp="38t8nkramj4lf">
          {number}
        </span>
        <Icon className="h-4 w-4 flex-shrink-0 text-navy-600" aria-hidden="true" data-id="element-298" data-mp="3cukincc9oi10" />
        <h2 id={headingId} className="text-[13px] font-semibold text-gray-900" data-id="element-299" data-mp="3hu6xfq7qu6bx">
          {title}
        </h2>
        {aside && <div className="ml-auto" data-id="element-300" data-mp="1ihumsp2c8yqz">{aside}</div>}
      </div>
      <div className="px-1 pt-4" data-id="element-301" data-mp="1ij5ngg0hlqdv">{children}</div>
    </section>;
}
export function FieldLabel({
  htmlFor,
  children,
  required
}: {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
}) {
  return <label htmlFor={htmlFor} className="mb-2 block text-[13px] font-medium text-gray-700" data-id="element-302" data-mp="1k13ownej78pm">
      {children}
      {required && <span className="text-danger" data-id="element-303" data-mp="1fyywfrztki4k"> *</span>}
    </label>;
}